import { JSX, useState } from "react";
import styles from "./GameSelector.module.css";
import AddNumberOfPlayers from "./components/AddNumberOfPlayers";
import AddRoomNumber from "./components/AddRoomNumber";
import StartGameOptions from "./components/StartGameOptions";
import RoomNumberDisplay from "./components/RoomNumberDisplay";

export default function GameSelector() {
  const [hasChosenGame, setHasChosenGame] = useState<boolean>(false);
  const [isNewGame, setIsNewGame] = useState<boolean>(false);
  const [isExistingGame, setExistingGame] = useState<boolean>(false);
  const [codeRequested, setCodeRequested] = useState<boolean>(false);

  let content: JSX.Element | null = null;

  const handleOnClickNewGame = () => {
    setHasChosenGame(true);
    setIsNewGame(true);
  };

  const handleOnClickJoinGame = () => {
    setHasChosenGame(true);
    setExistingGame(true);
  };

  if (!hasChosenGame) {
    content = (
      <StartGameOptions
        onClickNewGame={handleOnClickNewGame}
        onClickJoinGame={handleOnClickJoinGame}
      />
    );
  } else if (isNewGame) {
    if (!codeRequested) {
      content = <AddNumberOfPlayers setCodeRequested={setCodeRequested} />;
    } else {
      content = <RoomNumberDisplay />;
    }
  } else if (isExistingGame) {
    content = <AddRoomNumber />;
  }

  if (content != null) {
    content = (
      <div className={styles.wrapper}>
        <div className={styles.inner}>{content}</div>
      </div>
    );
  }

  return content;
}
